



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import publishObjectPath from '@/util/configRegistry';
@Component({
  name: 'LayoutBanner',
})
export default class LayoutBanner extends Vue {
    @Injectable() public container!: Container;

    private logoDatas: any = publishObjectPath.value.portal.topLogo;
    private imgSrc: any = publishObjectPath.value.portal.topLogo.imgSrc;
    constructor() {
        super();
    }

   /* private changeTheme() {
        let themes = ['theme1', 'theme2', 'theme3'];
        let dom = document.getElementById('theme');
        let index: number = (dom as any).selectedIndex;
        let theme: string = themes[index];
        /!* 方案一: public大方案
        ***************************!/
        less.modifyVars({
            '@theme': theme
        });
    }*/

    private changeTheme(theme: string) {
        window.document.documentElement.setAttribute('data-theme', theme);
    }
    private created() {
         this.changeTheme('theme1');
      }
}
